import {checkBrandIsGenderSensitive} from "./check-brand-is-gender-sensitive";

export function showGenderColsIfBrandIsGenderSensitive(statement, $context) {
    const isBrandGenderSensitive = checkBrandIsGenderSensitive($context);
    if (isBrandGenderSensitive || $context.find('.forceBrandGenderSensitive').length) {
        $(statement).find('[data-statement-brand-gender-col]').each(function () {
            $(this).removeClass('hide');
        });
    }

    return statement;
}
